import { IRichText } from '@belong/types/ui';
import { Entry } from 'contentful';
import { FRichText } from '../richText.factory';

export interface IElementCountryList {
  content: IRichText;
  countries: string[];
  showListLabel: string;
  hideListLabel: string;
  inlineText?: string;
}

export const FElementCountryList = (data: Entry<any>): IElementCountryList => {
  const {
    countries,
    showCountriesLinkLabel: showListLabel,
    hideCountriesLinkLabel: hideListLabel,
    inlineText,
    countryListCopy
  } = data.fields;
  return {
    content: FRichText(countryListCopy),
    countries,
    showListLabel,
    hideListLabel,
    inlineText
  };
};
